import React from "react";
import { Link } from "react-router-dom";
import "./components.css";
// import icons pack
import Ionicon from "react-ionicons";
// import videos
// import Video from "../../assets/videos/mainpage.mp4";
// video navigation icons
import Play from "../../assets/images/mainpage/play_icon.png";
import Pause from "../../assets/images/mainpage/pause_icon.png";
import Thumbnial from "../../assets/images/mainpage/video_thumbnail.png";

export default class SectionVideo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      videoPlay: false
    };
  }
  componentDidMount() {
    //   initializze variables
    this.videoButton = document.getElementsByClassName("videoButton")[0];
    this.videoItem = document.querySelectorAll(".videoPlayer video")[0];
    // set events
    this.videoButton.addEventListener("click", this.playPause);
    this.videoItem.addEventListener("click", this.playPause);
  }
//   remove events 
  componentWillUnmount() {
    this.videoButton.removeEventListener("click", this.playPause);
    this.videoItem.removeEventListener("click", this.playPause);
  }
  // video control
  playPause = e => {
    e.stopPropagation();
    e.preventDefault();
    this.setState({
      videoPlay: !this.state.videoPlay
    });
    if (this.state.videoPlay) {
      this.videoItem.play();
    } else {
      this.videoItem.pause();
    }
  };

  render() {
    return (
      <div className="sectionVideo">
        <div className="backgroundLayer">
          <canvas id="canvas" />
        </div>
        <div className="wrapper">
          <div className="wrapperHeading">Easy 3-Step Testing</div>
          <div className="wrapperBody">
            <div className="videoPlayer">
              {this.state.videoPlay ? (
                <img src={Pause} className="videoButton pause noselect" />
              ) : (
                <img src={Play} className="videoButton play noselect" />
              )}
              <video poster={Thumbnial} className="videoItem" loop>
                {/* <source src={Video} /> */}
              </video>
            </div>
          </div>

          <Link to="/register">
            <button className="buttonMid sectionButton">
              <span>START NOW IT’S FREE</span>
              <Ionicon
                icon="md-arrow-round-forward"
                fontSize="26px"
                color="#ffffff"
                className="btnIcon"
              />
            </button>
          </Link>
        </div>
      </div>
    );
  }
}
